function fetchCooperationDetailsQuery (id) {
  let variables = { id }

  return {
    operationName: 'fetchCooperationDetailsQuery',
    query: `
      query fetchCooperationDetailsQuery($id: Int!) {
        kooperation: cooperation(id: $id) {
          _entityName
          _stringRep
          titelKooperation:title
          kooperationsType:type
          organisationseinheit:organisationalUnit {
            _id:id
            _entityName
            _stringRep
            parentOrgaName
          }
          relevantFuerWeitere:hasMultipleOus
          weitereOrganisationseinheiten:additionalOrganisationalUnits {
            _id:id
            _stringRep
            _entityName
            parentOrgaName
          }
          ansprechpartner:contactPersons {
            _entityName
            _stringRep: fullName
            fisPersid
            orcid
          }
          beteiligtePersonen:involvedPersons {
            _entityName
            _stringRep: fullName
            fisPersid
            orcid
          }
          beteiligteOrganisationen:involvedOrganisations {
            _entityName
            _stringRep
            name
            kurzname:shortName
            stadt:city
            country {
              _id:id
              _stringRep
              _entityName
              nameDe
              nameEn
            }
          }
          _stringRep
          beginn:startDate
          ende:endDate
          kurzbeschreibung:abstract
          gastaufenthalte:guestStays
          gegenseiteHilfe:mutualSupport
          gemeinsameTagungen:jointMeetings
          gemeinsameThemen:commonTopics
          gemeinsamePublikationen:jointAuthoring
          doktorandenProgramm:doctoralProgramme
          andereKooperation:other
          kooperationsartFreitext:cooperationDetails
        }
      }
    `,
    variables
  }
}

export { fetchCooperationDetailsQuery }



// WEBPACK FOOTER //
// ./src/graphql/cooperationDetails.js